"use client"

import { Lollipop } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LollipopIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LollipopIcon = component(Icon)({ as: Lollipop })
